// Shared doubt-solving (Q&A) presentation bits — status/visibility vocabulary
// matches backend/server.py's DOUBT_STATUSES / DOUBT_VISIBILITIES exactly.
import { Badge } from "@/components/ui/badge";
import { Lock, Users } from "lucide-react";

export const DOUBT_STATUS_STYLES = {
    open: "bg-[#E64AA1] hover:bg-[#E64AA1] text-white",
    answered: "bg-[#FFA81B] hover:bg-[#FFA81B] text-white",
    resolved: "bg-[#16A34A] hover:bg-[#16A34A] text-white",
};

export function DoubtStatusBadge({ status }) {
    return (
        <Badge className={`text-[10px] uppercase tracking-wider ${DOUBT_STATUS_STYLES[status] || ""}`}>
            {status}
        </Badge>
    );
}

export function DoubtVisibilityBadge({ visibility }) {
    const shared = visibility === "shared";
    return (
        <Badge
            variant="outline"
            className={`text-[10px] uppercase tracking-wider gap-1 ${shared ? "border-[#726AF0] text-[#726AF0]" : "border-muted-foreground/40 text-muted-foreground"}`}
        >
            {shared ? <Users className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
            {shared ? "Shared" : "Private"}
        </Badge>
    );
}

export const DOUBT_STATUS_FILTERS = [
    { value: "ALL", label: "All statuses" },
    { value: "open", label: "Open" },
    { value: "answered", label: "Answered" },
    { value: "resolved", label: "Resolved" },
];
